import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockCategories, mockTopics } from '../data';

const CategoryView: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  
  const category = mockCategories.find(cat => cat.id === categoryId);
  const topics = mockTopics
    .filter(topic => topic.categoryId === categoryId)
    .sort((a, b) => {
      // Sticky topics first, then announcements, then by date
      if (a.isSticky && !b.isSticky) return -1;
      if (!a.isSticky && b.isSticky) return 1;
      if (a.isAnnouncement && !b.isAnnouncement) return -1;
      if (!a.isAnnouncement && b.isAnnouncement) return 1;
      return new Date(b.lastPostAt).getTime() - new Date(a.lastPostAt).getTime();
    });

  if (!category) {
    return (
      <div className="forum-container">
        <div className="forum-header">
          <h1 className="forum-title">Category Not Found</h1>
        </div>
        <div className="text-center">
          <p>The requested category could not be found.</p>
          <Link to="/" className="btn">Return to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="category-view">
      <div className="forum-container">
        <div className="forum-header">
          <h1 className="forum-title">{category.name}</h1>
          <p className="forum-description">{category.description}</p>
        </div>
        
        <ul className="topic-list">
          {topics.map(topic => (
            <li key={topic.id} className={`topic-item ${topic.isSticky ? 'sticky' : ''} ${topic.isAnnouncement ? 'announcement' : ''}`}>
              <div className="topic-header">
                <Link to={`/topic/${topic.id}`} className="topic-title">
                  {topic.title}
                  {topic.isSticky && <span style={{ color: '#ffff00' }}> [STICKY]</span>}
                  {topic.isAnnouncement && <span style={{ color: '#ff0000' }}> [ANNOUNCEMENT]</span>}
                </Link>
                <div className="topic-meta">
                  by <span className="topic-author">{topic.author.username}</span>
                </div>
              </div>
              <div className="topic-stats">
                <span>Posts: {topic.postCount}</span>
                <span>Views: {topic.viewCount}</span>
                <span>Created: {new Date(topic.createdAt).toLocaleDateString()}</span>
                <span>Last: {new Date(topic.lastPostAt).toLocaleDateString()}</span>
              </div>
            </li>
          ))}
        </ul>
        
        {topics.length === 0 && (
          <div className="text-center" style={{ padding: '40px' }}>
            <p>No topics found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryView; 